import ColorScheme, {
  type ColorSpecification,
  type ColorInputs,
} from './ColorScheme';
import Color from 'color';

// Subclasses generate colors to apply to a diagam. Also implements the default
// colors.
//
// When generating colors the caller must pass in which color in the sequence
// they want, and the total number of colors they will request. This allows the
// color scheme to generate colors that are visually distinct from each other,
// and also spanning a range evenly.
class GradientColorScheme extends ColorScheme {
  static baseObjectColor = '#0B2DA5';
  static baseConnectorColor = '#DE7F03';

  static objectColor(inputs: ColorInputs): ColorSpecification {
    let baseColor = Color(GradientColorScheme.baseObjectColor);
    const n = inputs.n || 0;
    const total = inputs.total || 1;

    baseColor = baseColor.lighten((0.9 * n) / total);
    return {
      stroke: baseColor.hex(),
      strokeWidth: 3,
      fill: '#FFFFFF',
      text: baseColor.hex(),
    };
  }

  static connectorColor(inputs: ColorInputs): ColorSpecification {
    let baseColor = Color(GradientColorScheme.baseConnectorColor);
    const n = inputs.n || 0;
    const total = inputs.total || 1;

    baseColor = baseColor.lighten((0.9 * n) / total);
    return {
      stroke: baseColor.hex(),
      strokeWidth: 3,
      fill: '#FFFFFF',
      text: baseColor.hex(),
    };
  }
}

export default GradientColorScheme;
